module.exports = __webpack_public_path__ + "img/샤로수길 고기집.3390a763.png";